import { BorrowerQuoteTabDto } from 'api/quote';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContractualizationTabs } from '../layout/ContractualizationTabs';

interface BorrowerTabProps {
  activeTab?: string;
  borrowerProjectId?: string;
  tabs: BorrowerQuoteTabDto[];
}

/**
 * Tabs component for borrower flow
 * Uses the generic ContractualizationTabs with borrower-specific navigation
 */
export const BorrowerTabs: FC<BorrowerTabProps> = ({
  activeTab,
  tabs,
  borrowerProjectId
}) => {
  const navigate = useNavigate();

  const handleTabClick = useCallback(
    (tabId: string, tab: BorrowerQuoteTabDto) => {
      navigate(
        `/simulation/contractualisation/borrower/${borrowerProjectId}/${tabId}/${tab.quoteId}`
      );
    },
    [navigate, borrowerProjectId]
  );

  const getTabId = useCallback((tab: BorrowerQuoteTabDto) => {
    return tab.borrowerId;
  }, []);

  const getTabName = useCallback((tab: BorrowerQuoteTabDto) => {
    return tab.borrowerName || tab.label;
  }, []);

  return (
    <ContractualizationTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabClick={handleTabClick}
      getTabId={getTabId}
      getTabName={getTabName}
    />
  );
};
